import {autoinject} from "aurelia-framework";

@autoinject
export class CountryService {
  getCountryCodeFromUrl(): string {
    let url = window.location.href;
    let fragments = url.substr(url.indexOf('newyorker.de/') + 13).split('/'); // split URL path in segments
    let cc = "DE";
    if (fragments && fragments.length > 0) {
      cc = fragments[0];
      if (!cc || cc === '' || cc.startsWith("host") || cc.length > 2) {
        cc = "DE";
      }
    }
    return cc;
  }

}
export const countryService = new CountryService();
